<template>
  <div class="main-title" :title="showDesc" v-if="questions.length>0">{{ showDesc }}</div>
</template>
<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'ExamThemeTitle',
    props: {
      isShowDesc: {
        type: Boolean,
        default: true
      }
    },
    computed: {
      ...mapGetters([
        'questions',
        'currentQuestionType'
      ]),
      showDesc() {
        let desc = `${this.questions[this.currentQuestionType].showSerialNum}、${this.questions[this.currentQuestionType].viewTypeName}`
        this.isShowDesc === true ? desc = `${desc}(${this.questions[this.currentQuestionType].quesTypeDesc})` : desc
        return desc
      }
    }
  }
</script>
<style lang="scss" scoped>
  .main-title {
    float: left;
    display: inline-block;
    height: 33px;
    font-size: 14px;
    font-weight: 700;
    padding-left: 40px;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 600px;
    overflow: hidden;
  }
</style>
